import 'angular:locale/data:en-GB';
import 'buffer';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-GB";
